import $ from 'jquery';
import _ from 'underscore';
import * as base64 from '../../../home24/core/base64';
import { setCookie } from '../../../home24-shared/core/Utils';

/**
 * @param {Object} data
 * @param {int=} quantity
 * @return {Object}
 */
export function prepareCartAddObject(data, quantity) {
  return prepareCartAddRemoveObject(data, 'addToCart', 'add', quantity);
}

/**
 * @param {Object} data
 * @param {int=} quantity
 * @return {Object}
 */
export function prepareCartRemoveObject(data, quantity) {
  return prepareCartAddRemoveObject(data, 'removeFromCart', 'remove', quantity);
}

/**
 * onClick event handler responsible for converting data-gtm html attributes into cookies
 * data-gtm is used to pass cpos, rpos and type attributes to GoogleTagManager
 *
 * @param {$} $currentTarget
 */
export function processGtmVariables($currentTarget) {
  var dataGtm = $currentTarget.data('gtm');
  var key;

  if (typeof dataGtm !== 'undefined' && dataGtm.length > 0) {
    dataGtm = decode(dataGtm);

    if (typeof dataGtm === 'object') {
      for (key in dataGtm) {
        /* istanbul ignore else */
        if (dataGtm.hasOwnProperty(key)) {
          setCookie(key, dataGtm[key]);
        }
      }
    }
  }
}

/**
 * Method extracts single article data base on SKU from trackingData array
 * @param {Array} trackingData
 * @param {String} sku
 * @return {Object|boolean}
 */
export function extractDataBySku(trackingData, sku) {
  var i;

  if (trackingData) {
    for (i in trackingData) {
      /* istanbul ignore else */
      if (trackingData.hasOwnProperty(i)) {
        if (trackingData[i].id === sku) {
          return trackingData[i];
        }
      }
    }
  }

  return false;
}

/**
 * Method checks if Google Tag Manager has been loaded and initialized
 * @return {boolean}
 */
export function isGTMLoaded() {
  if (typeof window.dataLayer !== 'undefined') {
    var i;

    for (i in window.dataLayer) {
      /* istanbul ignore else */
      if (window.dataLayer.hasOwnProperty(i)) {
        if (
          window.dataLayer[i].event &&
          window.dataLayer[i].event === 'gtm.load'
        ) {
          return true;
        }
      }
    }
  }

  return false;
}

/**
 * @param {Object} data
 * @param {String} event
 * @param {String} type
 * @param {int=} quantity
 * @return {{event: *, ecommerce: {}}}
 */
export function prepareCartAddRemoveObject(data, event, type, quantity) {
  var retVal = {
    event: event,
    ecommerce: {}
  };
  var aProducts = [];
  var oClonedData;
  var cartValue = 0;

  retVal.ecommerce[type] = {};
  retVal.ecommerce[type].products = [];

  // pdp cart overlay case
  if (_.isArray(data)) {
    _.each(data, function(prod) {
      aProducts.push($.extend(true, {}, prod));
    });

    retVal.ecommerce[type].products = [aProducts[0]];

    _.each(aProducts, function(prod) {
      cartValue += parseFloat(prod.price) * prod.quantity;
    });

    retVal.ecommerce.cartValue = cartValue.toFixed(2);
  } else {
    // cart page case
    oClonedData = $.extend(true, {}, data);

    if (quantity) {
      oClonedData.quantity = quantity;
    }

    aProducts.push(oClonedData);
    retVal.ecommerce[type].products = aProducts;
  }

  return retVal;
}

/**
 * @param {String} data
 * @return {Object|undefined}
 */
export function decode(data) {
  if (data) {
    try {
      return $.parseJSON(base64.decode(data));
    } catch (e) {
      return undefined;
    }
  } else {
    return undefined;
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/helper.js
 **/